module.exports = __webpack_public_path__ + "img/Slark.8fa4f1de.png";